import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from '../components/common/Button';
import { useUpdateEmailMutation } from '../redux/apiSlice';

const EmailUpdatePage: React.FC = () => {
  const navigate = useNavigate();
  const [updateEmail, { isLoading }] = useUpdateEmailMutation();
  const [message, setMessage] = useState<string | null>(null);

  const searchParams = new URLSearchParams(window.location.search);
  const email = searchParams.get('new_mail');

  const handleUpdateEmail = async () => {
    if (!email) {
      toast.error('Missing new email in the URL');
      return;
    }

    try {
      const response = await updateEmail({ email }).unwrap(); // Update the call to use email
      toast.success('Email update successful!');
      setMessage(response.message); // Assuming the response contains a message
      console.log('Email update successful:', response);
      navigate('/');
    } catch (err: any) {
      toast.error(err?.data?.message || 'Email update failed');
      console.error('Email update failed:', err);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white shadow-lg rounded-lg w-full max-w-md p-8 border border-gray-200">
        <h2 className="text-2xl font-semibold mb-4 text-center">
          Update Email
        </h2>

        {email && (
          <p className="text-lg mb-2">
            <strong>New Email:</strong> {email}
          </p>
        )}
        {message && (
          <div className="mt-4">
            <p className="text-lg font-semibold text-green-500">Message:</p>
            <p className="text-lg text-gray-700">
              <strong>{message}</strong>
            </p>
          </div>
        )}
        <Button
          onClick={handleUpdateEmail}
          disabled={isLoading}
          className={`w-full py-2 px-4 rounded-md ${
            isLoading
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-blue-600 text-white hover:bg-blue-500'
          } transition-colors duration-200`}
        >
          {isLoading ? 'Updating...' : 'Update Email'}
        </Button>
      </div>
    </div>
  );
};

export default EmailUpdatePage;
